import { render } from "./ProjectInfoSection.vue?vue&type=template&id=b8d98854&ts=true"
import script from "./ProjectInfoSection.vue?vue&type=script&lang=ts"
export * from "./ProjectInfoSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__